import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { Meta } from '@angular/platform-browser';

export interface PublicAlertDto {
  id: number;
  alertTypeName: string;
  status: string;
  judicialDistrict: string;
  requestedByUserName: string;
  start: string;
  numCalls: number;
}

@Component({
  selector: 'app-public-alerts',
  templateUrl: './public-alerts.component.html',
  styleUrls: ['./public-alerts.component.scss'],
})
export class PublicAlertsComponent implements OnInit, OnDestroy {
  alerts: PublicAlertDto[] = [];
  errorMessage: string | null = null;
  private token: string;
  private pollingSub: Subscription;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private meta: Meta
  ) {}

  ngOnInit(): void {
    document.body.classList.add('public-view');
    this.meta.addTag({ name: 'robots', content: 'noindex' });

    this.token = this.route.snapshot.queryParams['token'];
    this.loadAlerts();

    this.pollingSub = interval(5 * 60 * 1000).subscribe(() =>
      this.loadAlerts()
    );
  }

  ngOnDestroy(): void {
    document.body.classList.remove('public-view');
    this.meta.removeTag('name="robots"');

    if (this.pollingSub) {
      this.pollingSub.unsubscribe();
    }
  }

  private loadAlerts(): void {
    this.http
      .get<PublicAlertDto[]>('/api/public/alerts', {
        params: { token: this.token },
      })
      .subscribe({
        next: (data) => {
          this.alerts = data;
          this.errorMessage = null;
        },
        error: (err: HttpErrorResponse) => {
          if (err.status === 401) {
            this.errorMessage = 'Acceso no autorizado. Token inválido.';
          }
        },
      });
  }
}
